import {myConstants} from './Constants';


/*
 * Liefert den Namen von dem Besuchstyp zurück
*/
export function VacationType(vacationType) 
{
  if (vacationType === myConstants.saturday)
  {
    return "Tagesgäste";
  } 
  else if (vacationType === myConstants.weekend)
  {
    return "Wochenendgäste";    
  }
  else
  {
    return "Übernachtungsgäste";
  }
}


export function VacationTypeShort(vacationType)
{
  if (vacationType === myConstants.saturday)
  {
    return "TG";
  } 
  else if (vacationType === myConstants.weekend)
  {
    return "WG";    
  }
  else
  {
    return "ÜG";
  }
}


export function FirstDay(firstDay)
{
  if (firstDay === myConstants.fd_friday)
  {
    return "Freitagabend";
  }
  else if (firstDay === myConstants.fd_saturday)
  {
    return "Samstagmorgen";
  }
  else
  {
    return;
  }
}

/*
 * Wandelt eine arabische Ziffer in eine römische Zahl um
*/
export function Arabic2Roman(arabic)
{
  const roman = [ 0, 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X' ];
  let integer = parseInt(arabic);
  if ((integer === 0)||(integer > roman.length))
    integer = 1;
  return '(' + roman[integer] + ')';

};


export function TeamLabel(teamLabel, teamCounter)
{
  return teamLabel + (teamCounter > 1 ? Arabic2Roman(teamCounter) : '' );
}